var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('macro-component',{attrs:{"view":"macro-menu-options","listPosition":"left","containerWith":"14rem","icon":"arror-right","route":"/FrontOffice/Transactions"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }